import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SettingsBar = _resolveComponent("SettingsBar")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_SettingsPageLayout = _resolveComponent("SettingsPageLayout")!

  return (_openBlock(), _createBlock(_component_SettingsPageLayout, null, {
    default: _withCtx(() => [
      (!_ctx.emptyItems)
        ? (_openBlock(), _createBlock(_component_SettingsBar, {
            key: 0,
            createLabelI18N: "common.camera_group_create",
            hasCreate: _ctx.modelAcl.add,
            onSearch: _cache[0] || (_cache[0] = (v) => (_ctx.module.filter.current.name_contains = v)),
            onCreate: _ctx.handleCreate
          }, {
            stats: _withCtx(() => [
              _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"])
            ]),
            _: 1
          }, 8, ["hasCreate", "onCreate"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NTable, {
        columns: _ctx.cameraGroupColumns,
        content: _ctx.items,
        "selected-items-ids": _ctx.selectedItemsIds,
        "disabled-items-ids": _ctx.disabledItemIds,
        disabled: !_ctx.modelAcl.update,
        "onSelect:changes": _ctx.handleSelectChanges,
        onAction: _ctx.handleTableAction,
        onSort: _ctx.handleTableSort
      }, null, 8, ["columns", "content", "selected-items-ids", "disabled-items-ids", "disabled", "onSelect:changes", "onAction", "onSort"]),
      _createVNode(_component_InfiniteScroll, {
        filters: _ctx.module.filter.current,
        onLoadMore: _cache[1] || (_cache[1] = () => _ctx.module.append())
      }, null, 8, ["filters"])
    ]),
    _: 1
  }))
}